import { memo } from 'react';

import { ShareButton } from '~/components/AssetModalV2/Header/components/ShareButton';
import { usePublicBoardAssetShare } from '~/components/AssetModalV2/Header/PublicBoardAssetComponents/usePublicBoardAssetShare';
import { ASSET_SHARE_BUTTON_PUBLIC } from '~/constants/testIDs';

export const PublicBoardAssetShareButton = memo(() => {
  const { sharePublicBoardAsset } = usePublicBoardAssetShare();

  return <ShareButton onClick={sharePublicBoardAsset} dataTestId={ASSET_SHARE_BUTTON_PUBLIC} />;
});

PublicBoardAssetShareButton.displayName = 'PublicBoardAssetShareButton';
